export function initCompare(selector) {
  document.querySelectorAll(selector).forEach(function (el) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayDone = false;
    var autoplayFrame = null;

    function setPos(pos) {
      pos = Math.max(0, Math.min(100, pos));
      el.style.setProperty('--pos', pos + '%');
      el.setAttribute('aria-valuenow', Math.round(pos));
    }

    function posFromClientX(clientX) {
      var rect = el.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function cancelAutoplay() {
      if (autoplayFrame !== null) {
        cancelAnimationFrame(autoplayFrame);
        autoplayFrame = null;
      }
      autoplayDone = true;
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function playAutoSweep() {
      if (autoplayDone || reduceMotion) return;
      autoplayDone = true;

      var keyframes = [50, 18, 82, 50];
      var segmentMs = 650;
      var start = null;

      function step(ts) {
        if (start === null) start = ts;
        var elapsed = ts - start;
        var segment = Math.min(Math.floor(elapsed / segmentMs), keyframes.length - 2);
        var segStart = keyframes[segment];
        var segEnd = keyframes[segment + 1];
        var segT = Math.min((elapsed - segment * segmentMs) / segmentMs, 1);
        setPos(segStart + (segEnd - segStart) * easeInOutCubic(segT));

        if (elapsed < segmentMs * (keyframes.length - 1)) {
          autoplayFrame = requestAnimationFrame(step);
        } else {
          setPos(50);
          autoplayFrame = null;
        }
      }
      autoplayFrame = requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playAutoSweep();
            observer.disconnect();
          }
        });
      }, { threshold: 0.4 });
      observer.observe(el);
    } else {
      playAutoSweep();
    }

    var dragging = false;

    function onPointerDown(e) {
      cancelAutoplay();
      dragging = true;
      el.classList.add('dragging');
      el.setPointerCapture(e.pointerId);
      setPos(posFromClientX(e.clientX));
    }

    function onPointerMove(e) {
      if (!dragging) return;
      setPos(posFromClientX(e.clientX));
    }

    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('dragging');
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerUp);

    el.addEventListener('keydown', function (e) {
      var current = parseFloat(el.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') {
        cancelAutoplay();
        setPos(current - 5);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        cancelAutoplay();
        setPos(current + 5);
        e.preventDefault();
      }
    });

    setPos(50);
  });
}
